import type { FotoRef } from '@wertermittlung/shared';
import { api } from '../../lib/api.js';
import { el } from '../../lib/dom.js';
import type { WizardCtx } from './types.js';

/**
 * Foto-Leiste: Upload sofort an den Server (re-encodiert, EXIF-frei),
 * im Protokoll-JSON liegt nur die Referenz {id, caption}.
 */
export function fotoRow(
  ctx: WizardCtx,
  fotos: FotoRef[],
  opts: { captions?: boolean } = {},
): HTMLElement {
  const row = el('div', { class: 'fotorow' });

  fotos.forEach((f, i) => {
    const item = el('div', { class: 'fotoitem' });
    const box = el('div', { class: 'foto' });
    box.append(
      el('img', { src: api.fotoUrl(ctx.p.id, f.id), alt: f.caption || 'Foto', loading: 'lazy' }),
    );
    const remove = el('button', { type: 'button', 'aria-label': 'Foto entfernen' }, '×');
    remove.addEventListener('click', () => {
      void api.fotoLoeschen(ctx.p.id, f.id).catch(() => undefined);
      fotos.splice(i, 1);
      ctx.save();
      ctx.rerender();
    });
    box.append(remove);
    item.append(box);
    if (opts.captions) {
      const cap = el('input', { type: 'text', placeholder: 'Bildunterschrift …' });
      cap.value = f.caption;
      cap.addEventListener('input', () => {
        f.caption = cap.value;
        ctx.save();
      });
      item.append(cap);
    }
    row.append(item);
  });

  const add = el('button', { class: 'btn-foto', type: 'button' }, '📷 Foto');
  const file = el('input', { type: 'file', accept: 'image/*', multiple: 'multiple' });
  file.hidden = true;
  add.addEventListener('click', () => file.click());
  file.addEventListener('change', async () => {
    add.disabled = true;
    add.textContent = 'lädt …';
    try {
      for (const f of Array.from(file.files ?? [])) {
        const { id } = await api.fotoHochladen(ctx.p.id, f);
        fotos.push({ id, caption: '' });
      }
      ctx.save();
      ctx.rerender();
    } catch {
      add.textContent = 'Fehler';
      setTimeout(() => ctx.rerender(), 1500);
    }
  });
  row.append(add, file);
  return row;
}
